module.exports = __webpack_public_path__ + "assets/feedbackicon-2.44464b59.svg";